import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { message, notification, Modal } from 'antd';

const container = document.getElementById('root')!;
const root = createRoot(container);

if (window.__POWERED_BY_WUJIE__) {
  const mount = () => {
    root.render(<App {...window.$wujie?.props} />);
  };

  const unmount = () => {
    // 切换应用时，关闭弹窗
    Modal.destroyAll();
    message.destroy();
    notification.destroy();
    root.unmount();
  };

  // 通过 props 转传入的 wujieMode 来判断是否需要改造生命周期
  if (window.$wujie?.props?.wujieMode === 'rebuild') {
    mount();
  } else {
    window.__WUJIE_MOUNT = mount;
    window.__WUJIE_UNMOUNT = unmount;
  }
} else {
  root.render(<App />);
}
